const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
};

const whatsappLead = (state = initialState, action) => {
    switch (action.type) {
        case "GET_ALL_WHATSAPP_LEADS":
            const responseData = action.data;
            
            // Extract data array - check if data is directly an array or nested
            const dataArray = Array.isArray(responseData?.data) 
                ? responseData.data 
                : responseData?.docs 
                || responseData?.whatsappLeadData 
                || (Array.isArray(responseData) ? responseData : []);
            
            // Extract total count - check multiple possible locations
            const totalCount = responseData?.totalCount 
                || responseData?.totalDocs 
                || responseData?.pagination?.total 
                || responseData?.total 
                || (Array.isArray(responseData) ? responseData.length : 0);
            
            return {
                ...state,
                allData: dataArray,
                total: totalCount,
            };
        default:
            return state;
    }
};

export default whatsappLead;
